import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Sidebar from "../../../components/sidebar/sidebar";
import { Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import { fetchWeeklyGroupReportService } from "../../../services/reportService";
import { getAllAgentsService } from "../../../services/agentService";
import { toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx"; // Import XLSX for Excel export
import { fetchEnquiresService } from "../../../services/customerService";

function Enquiry() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [enquires, setEnquires] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [customer, setcustomer] = useState([]); // Assuming you will fetch the customer
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCollections, setTotalCollections] = useState();
  const [agents, setAgents] = useState([]);
  const initialValues = {
    fromDate: null,
    toDate: null,

    status: "",
  };

  const statuses = ["pending", "unpaid", "paid"];

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService();
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };

  //   const handleFilter = () => {
  //     fetchPigmy();
  //     // Fetch or filter customer based on fromDate and toDate
  //   };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchEnquires = async (values) => {
    try {
      const getLoans = await fetchEnquiresService(
        values.fromDate, // Formik values now being used
        values.toDate,
        page,
        rowsPerPage,
        values.status
      );
      setEnquires(getLoans?.enquires);
      setTotalCollections(getLoans?.totalCollections);
      // setExcelData(getLoans?.excelData); // Adjust this based on API response structure
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  //   const handleExport = () => {
  //     const data = excelData.map((row, index) => ({
  //       "SL.NO": index + 1,
  //       "Group Name": row?.loan?.groupLoanId?.groupName,
  //       "Agent Name": row?.agent?.userName || "",
  //       "Customer Name": row?.user?.userName || "",
  //       "Phone Number": row?.user?.primaryPhone?.contactValue || "",
  //       "Loan Code": row?.loan?.loanCode || "",
  //       "Loan Amount": row?.loan?.loanAmount || "",
  //       Frequency: row?.loan?.frequency || "",
  //       "Due Date": moment(row?.dueDate).format("DD-MM-YYYY") || "",
  //       "Collection Day": row?.collectionDay || "",
  //       "Collection Amount": row?.collectionAmount || "",
  //       "Collected Date": row?.collectionDate
  //         ? moment(row.collectionDate).format("DD-MM-YYYY")
  //         : "-",
  //       Status: row?.status || "",
  //     }));
  //     const worksheet = XLSX.utils.json_to_sheet(data);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Collection Report");
  //     XLSX.writeFile(workbook, "WeeklyGroupLoanCollectionReport.xlsx");
  //   };

  useEffect(() => {
    fetchAgents();
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchEnquires(initialValues); // fetch loans based on initial filter values
  }, [page, rowsPerPage]); // re-fetch loans on page or rowsPerPage change

  return (
    <>
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Enquires</Typography>
            </Box>
            <Paper
              style={{
                color: "#000",
                padding: "20px",
                marginTop: 20,
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                // backgroundColor: "#f7f7ff",
              }}
            >
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                  fetchEnquires(values); // Pass Formik values when filtering
                }}
              >
                {({ values, handleChange, setFieldValue, errors, touched }) => (
                  <Form>
                    <Box>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={2}>
                          <Typography variant="body2" color="#333">
                            From Date
                          </Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            size="small"
                            value={values.fromDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={{
                              borderRadius: "5px",
                              backgroundColor: "#fff",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "5px",
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <Typography variant="body2" color="#333">
                            To Date
                          </Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            size="small"
                            value={values.toDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={{
                              borderRadius: "5px",
                              backgroundColor: "#fff",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "5px",
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={4} textAlign="center">
                          <Typography variant="body2" color="#333">
                            Actions
                          </Typography>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<i className="fas fa-filter"></i>}
                            sx={{
                              borderRadius: "5px",
                              padding: "6px 12px",
                              marginRight: "10px",
                              backgroundColor: "#5252ff",
                              "&:hover": { backgroundColor: "#3b3bb3" },
                            }}
                          >
                            Filter
                          </Button>
                          {/* <Button
                            variant="contained"
                            color="success"
                            onClick={handleExport}
                            sx={{
                              borderRadius: "5px",
                              padding: "6px 12px",
                              backgroundColor: "green",
                              color: "#fff",
                              "&:hover": { backgroundColor: "#006400" },
                            }}
                          >
                            Download Excel
                          </Button> */}
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>

            <Box sx={{ mt: 2 }}>
              {" "}
              <TableContainer>
                <Table
                  sx={{
                    minWidth: 650,
                    borderCollapse: "separate",
                    borderSpacing: "0 8px",
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                      {[
                        "SL.NO",
                        "Customer Name",
                        "Phone Number",
                        "Alternative Phone Number",
                        "Requested Date",
                        "Loan Amount",
                        "Status",
                      ].map((header) => (
                        <TableCell
                          key={header}
                          sx={{
                            color: "#5252ff",
                            padding: "6px",
                            fontWeight: "bold",
                            borderBottom: "1px solid #e0e0e0",
                            textAlign: "center",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {enquires?.length > 0 ? (
                      enquires.map((row, index) => (
                        <TableRow
                          key={row._id}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#fafafa" : "#ffffff",
                            borderRadius: "8px",
                            boxShadow: 1,
                          }}
                        >
                          <TableCell
                            sx={{ padding: "6px", textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            sx={{ padding: "6px", textAlign: "center" }}
                          >
                            {row?.name}
                          </TableCell>
                          <TableCell
                            sx={{ padding: "6px", textAlign: "center" }}
                          >
                            {row?.phoneNumber}
                          </TableCell>
                          <TableCell
                            sx={{ padding: "6px", textAlign: "center" }}
                          >
                            {row?.altMobNum}
                          </TableCell>
                          <TableCell
                            sx={{ padding: "6px", textAlign: "center" }}
                          >
                            {moment(row?.createdAt).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell
                            sx={{ padding: "6px", textAlign: "center" }}
                          >
                            {row?.loanAmount}
                          </TableCell>

                          <TableCell
                            sx={{ padding: "6px", textAlign: "center" }}
                          >
                            {row?.status}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={12}
                          sx={{ textAlign: "center", padding: "16px" }}
                        >
                          No enquires available in table
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={totalCollections}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Show"
                sx={{
                  "& .MuiTablePagination-actions": { margin: "0 12px" },
                  mt: 2,
                }}
              />
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
      </div>
    </>
  );
}

export default Enquiry;
